import Block from '@/components/Block'
import Button from '@/components/Button'
import { Stack } from '@/components/Layout'
import Text from '@/components/Text'
import { AccessMessageSection } from '@/shared/api-generated-types'
import classNames from 'classnames/bind'
import DOMPurify from 'isomorphic-dompurify'
import * as styles from './style'

const cx = classNames.bind(styles)

export interface Props extends Partial<AccessMessageSection> {
  className?: string
}
const AccessMessageBlock = ({ className = '', ...props }: Props): JSX.Element => {
  const classes = cx({
    root: true,
    [className]: true,
  })

  const ContainerType = (): string | undefined => {
    switch (props.content?.id) {
      case 'free':
        return `${styles.freeContainer}`
      case 'partner-locked':
        return `${styles.partnerContainer}`
      case 'upgrade':
        return `${styles.upgradeContainer}`
      default:
        return undefined
    }
  }
  return (
    <Block className={ContainerType()}>
      <Stack y className={classes}>
        <Stack x justifyContent="start" alignItems="center" spaceBetweenX="sm" className={styles.top}>
          {props.content?.iconUrl ? <img className={styles.lock} src={props.content?.iconUrl} /> : null}
          {props.content?.title ? (
            <Text
              weight="lg"
              size="xs"
              responsiveSize={{
                desktop: 'lg',
              }}
            >
              <span className={styles.title} dangerouslySetInnerHTML={{ __html: props.content.title }} />
            </Text>
          ) : null}
        </Stack>
        <Stack justifyContent="flex-start" spaceBetweenX="lg" className={styles.bottom}>
          {props.content?.description ? (
            <Text tag="p" className={styles.desc} size="xs" weight="sm">
              <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(props.content.description) }} />
            </Text>
          ) : null}

          {props.content?.primaryAction && props.content?.primaryAction.__typename === 'UrlAction' ? (
            <div className={styles.ctaBlock}>
              <Button
                href={props.content.primaryAction.url}
                label={props.content.primaryAction.label}
                className={styles.cta}
                size="md"
                component="link"
              />
            </div>
          ) : null}
        </Stack>
      </Stack>
    </Block>
  )
}
export default AccessMessageBlock
